"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.sendMessage = sendMessage;
exports.register = register;
exports.unregister = unregister;
exports.reconnect = reconnect;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _MessagingService = _interopRequireDefault(require("../MessagingService"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

/**
 * Created by falknisius on 15.06.17.
 */
// eslint-disable-line
function getAppChannelName() {
  return _getAppChannelName.apply(this, arguments);
} // init channel
// if (target.registerForPrivateAblyChannelWithDeviceUuid) {
//   messageService.getChannel(APP_CHANNEL)
// }


function _getAppChannelName() {
  _getAppChannelName = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var applicationInstanceId;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 2:
            applicationInstanceId = _context.sent;
            return _context.abrupt("return", 'private:' + applicationInstanceId);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAppChannelName.apply(this, arguments);
}

var REGISTRATIONS = {};

function sendMessage(_x, _x2, _x3) {
  return _sendMessage.apply(this, arguments);
}

function _sendMessage() {
  _sendMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(eventName, message, applicationInstanceId) {
    var channelName, channel;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            channelName = 'private:' + applicationInstanceId;
            _context2.next = 3;
            return _MessagingService["default"].getChannel(channelName);

          case 3:
            channel = _context2.sent;

            _MessagingService["default"].sendMessage(channel, eventName, message);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _sendMessage.apply(this, arguments);
}

function register(_x4, _x5) {
  return _register.apply(this, arguments);
}

function _register() {
  _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(onMessage, caller) {
    var appChannel, appChannelCallbacks;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log('registering for app channel', caller);
            _context3.next = 3;
            return getAppChannelName();

          case 3:
            appChannel = _context3.sent;

            if (!_config["default"].registerForPrivateAblyChannelWithDeviceUuid) {
              _context3.next = 10;
              break;
            }

            _context3.next = 7;
            return _MessagingService["default"].getChannel(appChannel);

          case 7:
            _context3.next = 9;
            return _MessagingService["default"].registerChannel(appChannel, onMessage);

          case 9:
            // TODO: enter presence separately where needed (I'm thinking of QD and KESI Connect)
            // await messageService.enterPresence(appChannel, {})
            if (typeof REGISTRATIONS[appChannel] === 'undefined' || REGISTRATIONS[appChannel].indexOf(caller) === -1) {
              appChannelCallbacks = REGISTRATIONS[appChannel] || [];
              appChannelCallbacks.push(caller);
              REGISTRATIONS[appChannel] = appChannelCallbacks;
              console.log('ably register', REGISTRATIONS);
            }

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _register.apply(this, arguments);
}

function unregister(_x6, _x7) {
  return _unregister.apply(this, arguments);
}

function _unregister() {
  _unregister = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(onMessage, caller) {
    var appChannelName, appChannelCallbacks, index;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getAppChannelName();

          case 2:
            appChannelName = _context4.sent;

            if (!_config["default"].registerForPrivateAblyChannelWithDeviceUuid) {
              _context4.next = 8;
              break;
            }

            appChannelCallbacks = REGISTRATIONS[appChannelName];
            _context4.next = 7;
            return _MessagingService["default"].unregisterChannel(appChannelName, onMessage);

          case 7:
            if (appChannelCallbacks) {
              index = appChannelCallbacks.indexOf(caller);
              appChannelCallbacks.splice(index, 1);
              REGISTRATIONS[appChannelName] = appChannelCallbacks;
            }

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _unregister.apply(this, arguments);
}

function reconnect(_x8) {
  return _reconnect.apply(this, arguments);
}

function _reconnect() {
  _reconnect = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(onMessage) {
    var appChannelName;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getAppChannelName();

          case 2:
            appChannelName = _context5.sent;

            if (!_config["default"].registerForPrivateAblyChannelWithDeviceUuid) {
              _context5.next = 9;
              break;
            }

            _context5.next = 6;
            return _MessagingService["default"].getChannel(appChannelName);

          case 6:
            _context5.next = 8;
            return _MessagingService["default"].unregisterChannel(appChannelName);

          case 8:
            register(onMessage);

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _reconnect.apply(this, arguments);
}